<template>
  <div>
    <div class="TianCharts">
      <div class="brandSel">
        <div class="brandSel">
          <van-dropdown-menu active-color="#CC4545" :overlay="false">
            <van-dropdown-item
              v-model="value1"
              :options="option1"
              @change="getChannelList(value1)"
            />
          </van-dropdown-menu>
        </div>
        <div class="brandSel2">
          <van-dropdown-menu active-color="#CC4545" get-container=".brandSel2" :overlay="false">
            <van-dropdown-item
              v-model="value2"
              :options="option2"
              @change="getBrandList(value2)"
              class="right"
            />
          </van-dropdown-menu>
        </div>
      </div>
      <div class="Ytd">
        <span>YTD POS</span>
        <span style="color: rgba(13, 13, 13, 0.3)">(KRMB)</span>
        <div style="width:10px"></div>
        <b>{{YtdVal|NumFormat}}</b>
        <div style="width:30px"></div>
        <span>vs.ly</span>
        <div style="width:10px"></div>

        <b>{{ly}}</b>
      </div>
      <div id="myChart"></div>
    </div>
  </div>
</template>
<script>
import pos from "../../assets/jpg/pos.svg";
import lypos from "../../assets/jpg/LyPos.png";

import qs from "qs";
export default {
  data() {
    return {
      value1: "",
      value2: "",
      option1: [],
      option2: [],
      ChannelList: [],
      BrandList: [],
      posData: [],
      MyxAxis: [],
      lyPos: [],
      maxLy: 0,
      monthTo:'',
      monthFrom: '',
      YtdVal: "",
      ly: "",
    };
  },
  methods: {
    getTimeFT(){
      if(sessionStorage.getItem("DefTime")){
        this.monthTo=sessionStorage.getItem("DefTime")
        this.monthFrom=sessionStorage.getItem("DefTime").substr(0, 4) + "01"
      }
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          height: 280,
          backgroundColor: " rgba(177, 224, 118,0.8);",
          borderColor: "#DDDDDF", //边框颜色
          borderWidth: 1, //边框线宽度
          textStyle: {
            //文字样式
            fontFamily: "PingFangSC-Regular",
            fontSize: "12px",
            color: " #FFFFFF",
          },
        },
        legend: {
          bottom: "3%",
          right: "3.5%",

          itemWidth: 16,
          itemHeight: 16,
          data: [
            {
              name: "POS (`000)",
              icon: `image://${pos}`,
            },
            {
              name: "LY POS (`000)",
              icon: `image://${lypos}`,
            },
          ],
          selected: { "LY POS (`000)": true },
          textStyle: {
            color: "#626262",
            fontSize: 10,
            letterSpacing: 0,
            fontFamily: "PingFangSC-Regular",
          },
        },
        grid: [
          {
            show: false,
            left: "15%",
          },
        ],

        xAxis: {
          show: true,
          type: "category",
          boundaryGap: true,
          splitLine: { show: false },
          data: this.MyxAxis,
          axisLabel: {
            interval: 0,
            rotate: 40,
            show: true,
            textStyle: {
              fontFamily: "STYuanti-SC-Light",
              fontSize: 10,
              color: "#292929",
              letterSpacing: 0,
              textAlign: "center",
            },
          },
          axisLine: {
            lineStyle: {
              color: "white",
            },
          },
        },
        yAxis: [
          {
            name: ["POS (`000)", "LY POS (`000)"],
            show: true,
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
            axisLine: {
              lineStyle: {
                color: "white",
              },
            },
            axisLabel: {
              interval: 0,
              show: true,
              textStyle: {
                fontFamily: "STYuanti-SC-Light",
                fontSize: 10,
                color: "#292929",
                letterSpacing: 0,
                textAlign: "center",
              },
            },
            min: 0,
          },
        ],
        series: [
          {
            name: "LY POS (`000)",
            type: "line",
            data: this.lypos,
            yAxisIndex: 0,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#7C945A", //折线颜色
              },
            },
          },
          {
            name: "POS (`000)",
            type: "line",
            data: this.posData,
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: "#BFAA47",
                areaStyle: { type: "default" },
                lineStyle: { color: "#BFAA47" },
              },
            },
            areaStyle: {
              // 实现蓝白渐变色
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#BFAA47",
                  },
                  {
                    offset: 1,
                    color: "#FFFFFF",
                  },
                ]),
              },
            },
          },
        ],
      });
    },
    getChannelList(brand) {
      this.brand = brand;
      this.$addr
        .post(`weekly/getBrandList`, qs.stringify({ channel: brand }))
        .then((res) => {
          this.option2 = [];
          this.BrandList = res.data.data;
          this.BrandList.map((item, index) => {
            this.option2.push(
              Object.assign({}, item, {
                text: item.brandCd,
                value: item.brandCd,
              })
            );
          });
          this.option2.unshift({ text: "全品牌", value: "" });
          this.getChartsList();
          this.getSum();
        })
        .catch((error) => {
          // this.$toast('接受数据失败');
        });
    },
    getBrandList(channel) {
      this.channel = channel;
      this.$addr
        .post(`weekly/getChannelList`, qs.stringify({ brand: channel }))
        .then((res) => {
          this.ChannelList = res.data.data;
          this.option1 = [];
          this.ChannelList.map((item, index) => {
            this.option1.push(
              Object.assign({}, item, {
                text: item.channelNm,
                value: item.channelNm,
              })
            );
          });
          this.option1.unshift({ text: "全渠道", value: "" });
          this.getChartsList();
          this.getSum();
        })
        .catch((error) => {
          // this.$toast('接受数据失败');
        });
    },
    getChartsList() {
      // this.$emit("senDshopNm", this.value);
      this.$addr
        .post(
          `weekly/getTmallShopNmData`,
          qs.stringify({
            channel: this.value1,
            brand: this.value2,
            monthFrom: this.monthFrom,
            monthTo: this.monthTo,
          })
        )
        .then((res) => {
          this.posData = [];
          this.lypos = [];
          this.MyxAxis = [];
          this.ChannelList = res.data.data;
          this.ChannelList.map((item, index) => {
            this.posData.push(item.salesValue);
            this.MyxAxis.push(item.date);
            this.lypos.push(item.lySalesValue);
          });

          this.drawLine();
        })
        .catch((error) => {
          // this.$toast('接受数据失败');
        });
    },
    getChannelList1() {
      this.$addr
        .post(`weekly/getChannelList`, qs.stringify({ brand: this.value2 }))
        .then((res) => {
          this.ChannelList = res.data.data;
          this.option1 = [];
          this.ChannelList.map((item, index) => {
            this.option1.push(
              Object.assign({}, item, {
                text: item.channelNm,
                value: item.channelNm,
              })
            );
          });
          this.option1.unshift({ text: "全渠道", value: "" });
        })
        .catch((error) => {
          // this.$toast('接受数据失败');
        });
    },
    getBrandList1() {
      this.$addr
        .post(`weekly/getBrandList`, qs.stringify({ channel: this.value1 }))
        .then((res) => {
          this.option2 = [];
          this.BrandList = res.data.data;
          this.BrandList.map((item, index) => {
            this.option2.push(
              Object.assign({}, item, {
                text: item.brandCd,
                value: item.brandCd,
              })
            );
          });
          this.option2.unshift({ text: "全品牌", value: "" });
        })
        .catch((error) => {
          // this.$toast('接受数据失败');
        });
    },
    getSum() {
      this.$addr
        .post(
          "weekly/getSalesSumData",
          qs.stringify({
            weeklyFlag: 1,
            monthFrom: this.monthFrom,
            monthTo: this.monthTo,
            channel: this.value1,
            brand: this.value2,
          })
        )
        .then((res) => {
          this.YtdVal = res.data.data[0].salesValue;
          this.ly = res.data.data[0].ly;
        });
    },
  },
  mounted() {
    this.getChannelList1();
    this.getBrandList1();
    this.getChartsList();
    this.getSum();
  },
  beforeMount(){
    this.getTimeFT()
  },
  props:['myDefTime'],
  watch:{
    myDefTime:{
      handler(oldVal,newVal){
        console.log(newVal);
      },
      deep:true
    }
  }
};
</script>
<style scoped>
.Ytd {
  min-width: 100%;
  position: absolute;
  top: 10px;
  left: 12%;
  display: flex;
  margin-bottom: 10px;
  font-family: "PingFangSC-Medium";
  font-size: 13px;
  color: #191919;
  line-height: 18px;
  align-items: center;
  z-index: 5;
}
.Ytd b {
  line-height: 30px;
  opacity: 0.91;
  font-family: "Arial-BoldMT";
  font-size: 20px;
  color: #282828;
}
.Ytd p {
  font-family: "PingFangSC-Medium";
  font-size: 13px;
  color: #555555;
}
.TianCharts {
  position: relative;
  margin-top: 40px;
}
#myChart {
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 280px;
  /* margin-bottom: 20px; */
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.4);
}
.brandSel {
  position: relative;
}
.brandSel2 {
  position: relative;
}
.brandSel2 .van-dropdown-menu {
  position: absolute;
  z-index: 7;
  top: -33px;
  background: #ffffff;
  border: 1px solid #d15757;
  box-shadow: 0 3px 8px 0 rgba(177, 224, 218, 0.3);
  border-radius: 42.5px;
  width: 40%;
  height: 21px;
  right: 7px;
}

.brandSel .van-dropdown-menu {
  position: absolute;
  z-index: 7;
  top: -33px;
  background: #ffffff;
  border: 1px solid #d15757;
  box-shadow: 0 3px 8px 0 rgba(177, 224, 218, 0.3);
  border-radius: 42.5px;
  width: 40%;
  height: 21px;
}
.brandSel .van-dropdown-menu /deep/ .van-popup--top {
  width: 40%;
  background: rgba(1, 177, 152, 0.9);
  border-radius: 5%;
  top: 2px;
  left: 10px;
}
/deep/ .van-cell__value {
  display: none;
}
/deep/ .van-cell__title {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #ffffff;
}
/deep/ .van-cell {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-ellipsis {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #cc4545;
}
/deep/ .van-dropdown-menu__title::after {
  border-color: transparent transparent #cc4545 #cc4545;
}
/deep/ .van-dropdown-item__content {
  max-height: 55%;
}

.brandSel2 .van-dropdown-menu /deep/ .van-popup--top {
  width: 40%;
  background: rgba(1, 177, 152, 0.9);
  border-radius: 5%;
  top: 2px;
  left: 56.5% !important;
}
/deep/ .van-dropdown-menu__bar{
  height: 100% !important;
  background: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ButThr/ButThr_Charts.vue